import { z } from 'zod';
import { uuidSchema } from './common.schema';

// ─── Query Parameters ─────────────────────────────────────────────────────────

/** Languages seeded in search_index (see the search_index migration). */
export const SEARCH_LANG_CODES = ['en', 'enUS', 'enGB', 'de', 'fr', 'tr'] as const;
export const langCodeSchema = z.enum(SEARCH_LANG_CODES).default('en');

export const SearchQuerySchema = z.object({
  q: z.string().min(1).max(200),
  module: z.string().max(50).optional(),
  limit: z.coerce.number().int().min(1).max(50).default(20),
  lang_code: langCodeSchema,
});

export const SearchModulesQuerySchema = z.object({
  lang_code: langCodeSchema,
});

// ─── Response Schemas ─────────────────────────────────────────────────────────

export const SearchResultItemSchema = z.object({
  id: uuidSchema,
  module: z.string(),
  title: z.string(),
  description: z.string().nullable(),
  route: z.string(),
  icon: z.string().nullable(),
  category: z.string().nullable(),
  rank: z.number(),
});

export const SearchResponseSchema = z.object({
  success: z.literal(true),
  data: z.array(SearchResultItemSchema),
  meta: z.object({
    query: z.string(),
    total: z.number(),
    requestId: z.string(),
    timestamp: z.string(),
  }),
});

export const SearchModuleSchema = z.object({
  module: z.string(),
  label: z.string(),
  count: z.number(),
});

export const SearchModulesResponseSchema = z.object({
  success: z.literal(true),
  data: z.array(SearchModuleSchema),
  meta: z.object({
    requestId: z.string(),
    timestamp: z.string(),
  }),
});

// ─── Type Exports ─────────────────────────────────────────────────────────────

export type SearchQuery = z.infer<typeof SearchQuerySchema>;
export type SearchModulesQuery = z.infer<typeof SearchModulesQuerySchema>;
export type SearchResultItem = z.infer<typeof SearchResultItemSchema>;
export type SearchModule = z.infer<typeof SearchModuleSchema>;
